import { useEffect, useState } from "react";
import Api from "../Services/Api";
import { Link } from "react-router-dom";

const ValorCard = () => {
  const [dados, setDados] = useState({
    saldo_total: 0,              // ✅ saldo real do banco/extrato
    creditos_confirmados: 0,
    limite_disponivel: 0,        // ✅ pode ser negativo
    saques_solicitados: 0,
    points_balance: 0,
  });

  useEffect(() => {
    Api.get("/ledger-entries/me/balance")
      .then((res) => {
        const payload = res.data?.data ?? res.data ?? {};

        const saldo_total = Number(payload.saldo_total ?? payload.saldo_total_disponivel ?? 0);
        const creditos_confirmados = Number(payload.creditos_confirmados ?? 0);
        const points_balance = Number(payload.points_balance ?? 0);

        // ✅ regra: limite disponível = saldo_total - créditos_confirmados
        const limite_disponivel = Number(
          payload.limite_disponivel ?? (saldo_total - creditos_confirmados)
        );

        setDados({
          ...payload,
          saldo_total,
          creditos_confirmados,
          limite_disponivel,
          points_balance,
        });
      })
      .catch(console.error);
  }, []);

  const formatBRL = (v) =>
    Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  // ✅ regra do botão: pode sacar apenas se saldo_total > 0 (ou se quiser: saldo_total - saques_solicitados > 0)
  const podeSacar = dados.saldo_total - (dados.saques_solicitados || 0) > 0;

  return (
    <article className="card">
      <div className="card-header">
        <div className="card-title">
          <span>💰</span>
          <span>Saldo disponível</span>
        </div>
      </div>

      <div className="card-body">
        <div className="card-value">{formatBRL(dados.saldo_total)}</div>

        <div className="card-sub">Saldo total (banco/extrato)</div>

        <div className="card-breakdown">
          <div><strong>Créditos confirmados:</strong> {formatBRL(dados.creditos_confirmados)}</div>
          <div><strong>Limite disponível:</strong> {formatBRL(dados.limite_disponivel)}</div>
          <div><strong>Saques solicitados:</strong> {formatBRL(dados.saques_solicitados)}</div>
          <div><strong>Pontos acumulados:</strong> {Math.floor(Number(dados.points_balance || 0))}</div>
        </div>
      </div>

      <div className="card-footer-inline">
        <Link to="/solicitarsaque" className={`primary-btn ${!podeSacar ? "disabled" : ""}`}>
          Solicitar saque
        </Link>

        <a href="/ajuda" className="inline-link">Ajuda / FAQ</a>
      </div>
    </article>
  );
};


export default ValorCard;
